module.exports = __webpack_public_path__ + "908a7d793fbdc50d9784bce1132ba6e0.svg";